import React, { type FC } from 'react';

import cn from 'classnames';

import type { DeviceItemProps } from './types';

import styles from './styles.module.scss';

/**
 * Отдельный элемент выпадающего списка устройства (камера/микрофон/динамик)
 */
export const DeviceItem: FC<DeviceItemProps> = ({ option, selectedId, onChange }) => (
	<div
		title={option.label}
		className={cn(styles.DropDownItem, {
			[styles.selected]: selectedId === option.deviceId,
		})}
		onClick={() => onChange(option.deviceId)}
	>
		{option.label}
	</div>
);
